import React, { useState } from "react";
// components
import Card from "./Card";

const HomePage = () => {

  return (
    <div className="container">
      <div className="container-wrapper">
        <div className="container-feed">
          <div className="container-feed-posts">
            {/* cards or post */}
            <Card />
            <Card />
            <Card />
          </div>
        </div>
        <div className="container-info">
          <div className="container-info-profile">
            <img alt="profile info of users" src="./images/dummyProfile.jpg" />
            <div className="profile-info">
              <h3>Xettri Aleen</h3>
              <p>My Day With An AI Artist...</p>
            </div>
          </div>
          <div className="container-info-suggestions">
            <div className="suggestions-header">
              <span>Suggestions</span>
              <span>See All...</span>
            </div>
            <div className="suggestions-body">
              <div className="suggestions-profile">
                <div className="profile-data">
                  <img src="./images/suggestionsDummy.png" alt="" />
                  <div className="suggestions-profileInfo">
                    <h4>Eminem</h4>
                    <p className="friendsFollowed">
                      Followed by XettriAleen...
                    </p>
                  </div>
                </div>
                <div className="follow">Follow</div>
              </div>
              <div className="suggestions-profile">
                <div className="profile-data">
                  <img src="./images/suggestionsDummy.png" alt="" />
                  <div className="suggestions-profileInfo">
                    <h4>Eminem</h4>
                    <p className="friendsFollowed">Followed by XettriAleen</p>
                  </div>
                </div>
                <div className="follow">Follow</div>
              </div>
              <div className="suggestions-profile">
                <div className="profile-data">
                  <img src="./images/suggestionsDummy.png" alt="" />
                  <div className="suggestions-profileInfo">
                    <h4>Eminem</h4>
                    <p className="friendsFollowed">
                      Followed by XettriAleen...
                    </p>
                  </div>
                </div>
                <div className="follow">Follow</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
